import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'cc-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnInit {

  @Input() activeStep: number = 0;
  @Input() totalSteps: number = 3;
  @Output() stepperClicked = new EventEmitter<any>();

  constructor() { }

  ngOnInit() { }

}
